import { z } from 'zod/v4';

export const AdminUsersListByCompanyParamsSchema = z.object({
  companyId: z.string().min(1),
});

export type AdminUsersListByCompanyParams = z.infer<
  typeof AdminUsersListByCompanyParamsSchema
>;

export const AdminUserByCompanyRowSchema = z.object({
  id: z.string(),
  fullName: z.string().nullable(),
});

export type AdminUserByCompanyRow = z.infer<typeof AdminUserByCompanyRowSchema>;

export const AdminUsersListByCompanyResponseSchema = z.object({
  data: z.array(AdminUserByCompanyRowSchema),
  meta: z.object({
    count: z.number(),
    page: z.number(),
    pageSize: z.number(),
    totalCount: z.number(),
  }),
});

export type AdminUsersListByCompanyResponse = z.infer<
  typeof AdminUsersListByCompanyResponseSchema
>;
